import { BookingAction } from '../actions/booking-action';
import { CarOnlyFromCarAction } from '../actions/car-only/car-only-from-car-action';
import { CarOnlyFromMachineAction } from '../actions/car-only/car-only-from-machine-action';
import { StockSourceType } from '../types';
import { BookingWorld, WorldKind } from './booking-world';

/**
 * Nur Car/KFZ aktiv (SAF). Die Quelle Bufferstock existiert nicht.
 * Befüllen (KFZ→Maschine) und Rücknahme (M→KFZ) sind movement-los und ändern
 * nur das lokale Fahrzeuglager; die remote Car-Buchung passiert beim
 * Auftragsabschluss im Backend. KFZ→KFZ (Umlagerung) läuft als zweiphasiges
 * CarRelocationMovement.
 */
export class CarOnlyWorld implements BookingWorld {
  public readonly kind: WorldKind = 'car-only';

  private readonly actions: Partial<Record<StockSourceType, BookingAction>> = {
    [StockSourceType.CAR]: new CarOnlyFromCarAction(),
    [StockSourceType.MACHINE]: new CarOnlyFromMachineAction(),
  };

  /**
   * Liefert die Source-Action für die Car-only-Welt.
   * @param source Quell-Lagertyp der Buchung.
   * @returns Die Action für CAR oder MACHINE, sonst undefined (z.B. für BUFFERSTOCK).
   */
  public actionFor(source: StockSourceType): BookingAction | undefined {
    return this.actions[source];
  }
}
